export default __webpack_public_path__ + "static/media/icon_localization.04571fb9.svg";